import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/restroagent/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/restroagent/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/restroagent/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/restroagent/src/styles/tailwind.css");
